const WrittenFollowUpTemplate = `
  <div>
    <div id="discussion-summary">
      <h2>Summary</h2>
      <p>Please provide a concise summary of the key points discussed during the previous roundtable.</p>
    </div>
    <div id="discussion-questions">
      <h2>Discussion Questions</h2>
      <p>Answer the following questions as a follow-up to our original RoundTable discussion</p>
      <ol id="questions">
        <li>[Question]</li>
        <li>[Question]</li>
        <li>[Question]</li>
      </ol>
    </div>
    <div id="discussion-instructions">
      <h2>Peer Feedback Instructions</h2>
      <p>After submitting your response, read at least two of your classmates’ responses and post a reply.</p>
      <ul>
        <li>Did they change your perspective in any way?</li>
        <li>Do you agree or disagree? Why or why not?</li>
        <li>Can you add to their ideas?</li>
      </ul>
    </div>
  </div>    
`;

export { WrittenFollowUpTemplate };



// WEBPACK FOOTER //
// ./src/app/features/Sequences/Templates/WrittenFollowUpTemplate.js